import type { ReactNode } from 'react';

export type SplitTitleCopy = {
  title?: string;
  title_line1?: string;
  title_accent?: string;
  title_line2?: string;
};

function needsLeadingSpace(fragment: string): boolean {
  return !/^[,.;:!?)]/.test(fragment);
}

export function hasSplitTitle(copy?: SplitTitleCopy | null): boolean {
  return Boolean(copy?.title || copy?.title_line1 || copy?.title_accent || copy?.title_line2);
}

export function renderSplitTitle(
  copy: SplitTitleCopy | null | undefined,
  renderAccent?: (text: string) => ReactNode
): ReactNode {
  if (!copy) return null;
  if (copy.title) return copy.title;

  const line1 = copy.title_line1 ?? '';
  const accent = copy.title_accent ?? '';
  const line2 = copy.title_line2 ?? '';

  if (!line1 && !accent && !line2) return null;

  return (
    <>
      {line1}
      {accent ? (
        <>
          {line1 && needsLeadingSpace(accent) ? ' ' : null}
          {renderAccent ? renderAccent(accent) : accent}
        </>
      ) : null}
      {line2 ? (
        <>
          {(line1 || accent) && needsLeadingSpace(line2) ? ' ' : null}
          {line2}
        </>
      ) : null}
    </>
  );
}
